import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseShortcutsComponent } from './shortcuts.component';

@NgModule({
    declarations: [FuseShortcutsComponent],
    imports: [
        CommonModule,
        RouterModule,

        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt- md',
                'gt-lg'
            ]
        }),

        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatListModule,
        MatTooltipModule
    ],
    exports: [FuseShortcutsComponent],
    providers: [
        // CookieService
    ]
})
export class FuseShortcutsModule {}
